import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { mapSetSchema } from '../schemas/map-set.schema';

/**
 * Retrieves A Specific Map Set
 * @param id The ID of the Map Set being retrieved
 * @returns The Map Set
 */
export function getMapSetsId(this: unknown, id: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${fleetEnvironment.resolve(this).mapSetsUrl}/${id}`, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(mapSetSchema));
}
